import React, { useState } from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
// import { Tooltip } from 'react-tooltip';
import { Modal, Button, Tooltip } from 'antd';
import { geoCentroid, geoPath, geoMercator } from 'd3-geo';
 
const EmissionMapModal = ({ onClose, onSelect, geoJson = {}, geoData = [], currentCon = '' }) => {
  const [tooltipContent, setTooltipContent] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(true);
 
  const handleCountryClick = (country) => {
    const selected = geoData.find((data) => data.Country === country);
    if (selected) {
      setSelectedCountry(country);
      onSelect(selected.value);
      handleClose();
    }
  };
 
  const handleClose = () => {
    setIsModalVisible(false);
    onClose();
  };
 
  // Create a projection and path generator
  // const projection = geoMercator().center([10, 50]).scale(1100);
  const projection = geoMercator().center([0, 0]).scale(1100);
  const pathGenerator = geoPath().projection(projection);
 
  return (
    <Modal
      title={`Geographical coverage for ${currentCon}`}
      visible={isModalVisible}
      onCancel={handleClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      <ComposableMap
        projectionConfig={{
          // center: [0, 0], // Fixed center for Europe
          // scale:  1100, // Fixed scale for Europe
          scale:  1, // Fixed scale for Europe
        }}
        data-tip=""
        style={{ width: '100%', height: '100%' }}
      >
        <Geographies geography={geoJson}>
          {({ geographies }) =>
            geographies.map((geo) => {
const country = geo.properties.NAME;
              const match = geoData.find((data) => data.Country === country);
              const centroid = geoCentroid(geo);
              const [x, y] = projection(centroid);
 
              return (
                <g key={geo.rsmKey}>
                <Tooltip title= {match ? `${country}: ${match.value}` : country } >

                  <Geography
                    geography={geo}
                    onMouseEnter={() => {
                      if (match) {
                        setTooltipContent(`${country}: ${match.value}`);
                      } else {
                        setTooltipContent(country);
                      }
                    }}
                    onMouseLeave={() => setTooltipContent('')}
                    onClick={() => handleCountryClick(country)}
                    style={{
                      default: { fill: match ? '#e74c3c' : '#d6d6d6' },
                      hover: { fill: match ? 'green' : '#000' },
                      pressed: { fill: '#2c3e50' },
                    }}
                  />
                </Tooltip>
                  {/* {match && (
                    <text
                      x={x}
                      y={y}
                      textAnchor="middle"
                      alignmentBaseline="central"
                      style={{
                        fontSize: 10,
                        fill: '#000',
                        pointerEvents: 'none', // Ensures the text doesn't interfere with interactions
                      }}
                    >
                      {country}
                    </text>
                  )} */}
                </g>
              );
            })
          }
        </Geographies>
      </ComposableMap>
      {/* {tooltipContent && (
        <Tooltip
        className='tooltipMap'
          style={{
            position: 'absolute',
            top: '10px',
            left: '10px',
            zIndex: 1000,
          }}
        >
          {tooltipContent}
        </Tooltip>
      )} */}
    </Modal>
  );
};
 
export default EmissionMapModal;